import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchDiscounts = createAsyncThunk('discounts/fetch', async (token) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  const res = await axios.get('/discounts', { headers, withCredentials: true });
  return res.data;
});

export const createDiscount = createAsyncThunk('discounts/create', async ({ discount, token }, { rejectWithValue }) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    const res = await axios.post('/discounts', discount, { headers, withCredentials: true });
    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to create discount');
  }
});

const discountsSlice = createSlice({
  name: 'discounts',
  initialState: { items: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchDiscounts.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchDiscounts.fulfilled, (s, a) => { s.status = 'succeeded'; s.items = a.payload; })
     .addCase(fetchDiscounts.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
     .addCase(createDiscount.fulfilled, (s, a) => { s.items = [a.payload, ...s.items]; })
     .addCase(createDiscount.rejected, (s, a) => { s.error = a.payload || a.error.message; });
  }
});

export default discountsSlice.reducer;
